// Mémorisation de la position (fil, profils, dernier reel, reprise de lecture) : délai d'expiration
// réglé par l'admin (settings.position_memory_ttl_hours ; 0 = infini ; défaut 24 h). Au-delà de ce délai
// d'inactivité, tout est oublié et l'app rouvre le fil en haut, rafraîchi (web + mobile).
export const DEFAULT_TTL_HOURS = 24;
const LAST_ACTIVE_KEY = "yalola.lastActive";

let ttlMs = DEFAULT_TTL_HOURS * 3600e3;

export const ttlFromConfig = (config) => {
  const h = config?.settings?.position_memory_ttl_hours;
  if (h === 0 || h === "0") return Infinity;
  const n = Number(h);
  return (Number.isFinite(n) && n > 0 ? n : DEFAULT_TTL_HOURS) * 3600e3;
};
export const syncPositionTtl = (config) => { ttlMs = ttlFromConfig(config); };
export const positionTtlMs = () => ttlMs;
export const isPositionFresh = (at) => typeof at === "number" && at > 0 && Date.now() - at <= ttlMs;

// Registre des mémoires à vider quand le délai est dépassé (fil, profils, reels, vidéos…).
const clearers = new Set();
export const onPositionMemoryExpire = (fn) => { clearers.add(fn); return () => clearers.delete(fn); };
export const clearPositionMemory = () => { clearers.forEach((fn) => { try { fn(); } catch { /* noop */ } }); };

// Dernière activité sur l'appareil (survit au redémarrage) : sert au retour d'arrière-plan / à la rouverture.
export const touchLastActive = () => { try { localStorage.setItem(LAST_ACTIVE_KEY, String(Date.now())); } catch { /* noop */ } };
export const readLastActive = () => { try { return Number(localStorage.getItem(LAST_ACTIVE_KEY)) || 0; } catch { return 0; } };
export const isInactivityExpired = () => { const last = readLastActive(); return !!last && Date.now() - last > ttlMs; };

// Pages où l'on est « au milieu de quelque chose » : jamais renvoyé vers le fil.
const KEEP_PREFIXES = ["/live", "/mes-directs", "/chat", "/messages", "/admin", "/checkout", "/pay", "/onboarding", "/login", "/register", "/auth", "/kyc", "/reset", "/verify"];
export const shouldRedirectHome = (pathname) => !KEEP_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/") || pathname.startsWith(p + "?"));
